import React from "react";
import propTypes from "@styled-system/prop-types";
import { ButtonLinkStyle } from "./buttonLink.style";

const ButtonLink = ({ children, ...props }) => <ButtonLinkStyle role="link" {...props}>{children}</ButtonLinkStyle>;

ButtonLink.propTypes = {
  ...propTypes.space,
};

export default ButtonLink;
